const upper= 'A-Z';
const lower= 'a-z';
const number= '\\d';
const special= '@$!%*#?&.';

module.exports = {
    upper: upper,
    lower: lower,
    number: number,
    special: special,
    checkPassword: (password, { minCharacter, requiresUpperCaseLetters, requiresLowerCaseLetters, requiresNumbers, requiresSpecialCharacters }) => {    
        let rules = [];
        if (requiresUpperCaseLetters == true) {
            rules.push(upper);
        }
        if (requiresLowerCaseLetters == true) {
            rules.push(lower);
        }
        if (requiresNumbers == true) {
            rules.push(number);
        }
        if (requiresSpecialCharacters == true) {
            rules.push(special);
        }

        let part1 = rules.map(x => `(?=.*[${x}])`).join('');
        let end = `${part1}[A-Za-z\\d@$!%*?&.]{${minCharacter},}`;

        //return end;
        let r = RegExp(end);
        // console.log(r,password);
        return { regex: r, result: r.test(password) };
    },
};


